import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ContactCTA from '../../../components/home/ContactCTA';

const heroImage = 'https://www.intravis.com/hs-fs/hubfs/Products/Caps%20%20and%20Closures/intravis-caps-closure-inspection-products-1920x1280px.jpg?width=1920&height=1280&name=intravis-caps-closure-inspection-products-1920x1280px.jpg';
const productImage = 'https://www.intravis.com/hs-fs/hubfs/Products/Caps%20%20and%20Closures/intravis-caps-closure-inspection-production-hall-1920x1000px.jpg?width=1920&height=1000&name=intravis-caps-closure-inspection-production-hall-1920x1000px.jpg';
const capWatcherQLineImage = 'https://www.intravis.com/hubfs/Products/Caps%20%20and%20Closures/CapWatcher%20Q-Line/intravis-closure-capwatcher-closures-system-1920x1280px.jpg';
const capWatcherBLineImage = 'https://www.intravis.com/hubfs/Products/Caps%20%20and%20Closures/CapWatcher%20B-Line/intravis-closure-capwatcher-b-line-closures-system-1920x1280px-grey.jpg';
const capWatcherSCImage = 'https://www.intravis.com/hubfs/Products/Caps%20%20and%20Closures/CapWatcher%20SC/intravis-specialty-closure-capwatcher-sc-closure-inspection-1920x1280px.jpg';

const CapsClosuresInspection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <section
        className="relative text-white h-56 sm:h-72 md:h-96 mt-20 sm:mt-12"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.45), rgba(15, 23, 42, 0.45)), url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/40 pointer-events-none" />
        <div className="container mx-auto px-4 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold">Caps &amp; Closures Inspection</h1>
            <p className="mt-2 max-w-2xl">Complete closure inspection systems for reliable cap quality and packaging integrity.</p>
            <div className="mt-6">
              <Link to="/products/intravis" className="text-blue-200 hover:text-white font-medium">
                ← Back to Inspection Systems
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 lg:grid-cols-2 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Precision inspection for closures</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Intravis Caps &amp; Closures systems inspect threaded and non-threaded closures for contamination, flash, printing and dimensional compliance. Their modular inspection platforms are built to handle the extreme speeds of modern closure production.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                With smart cameras and advanced inspection software, these solutions make sure every cap leaves the line correctly formed, clean, and ready for secure packaging.
              </p>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
                  <h3 className="text-xl font-semibold mb-3">Inspection Focus</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>Thread integrity and closure shape</li>
                    <li>Surface contamination and flash</li>
                    <li>Print, embossing and color verification</li>
                    <li>Tamper-evident band inspection</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
                  <h3 className="text-xl font-semibold mb-3">Operational Benefits</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>Reduced rejects through automated defect detection</li>
                    <li>High throughput for modern capping lines</li>
                    <li>Flexible configuration for multiple cap types</li>
                    <li>Detailed traceability and reporting</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <img src={productImage} alt="Intravis Caps and Closures Inspection" className="w-full h-full rounded-3xl object-cover shadow-2xl" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Key Intravis products</h2>
          <div className="grid gap-6 md:grid-cols-3">
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={capWatcherQLineImage} alt="CapWatcher Q-Line" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">CapWatcher Q-Line</h3>
              <p className="text-gray-600 mb-4">360° closure inspection for high-speed cap production and bottling applications.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Designed for fast, inline closure inspection with full thread and seal checks.</p>
                <p>Benefits: high throughput, contamination detection, print verification.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={capWatcherBLineImage} alt="CapWatcher B-Line" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">CapWatcher B-Line</h3>
              <p className="text-gray-600 mb-4">Robust inspection designed for large-volume cap and closure applications with flexible cap handling.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Built for heavy-duty production with strong mechanical reliability.</p>
                <p>Benefits: consistent quality, flexible handling, low false rejects.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
            <div className="bg-white p-6 rounded-3xl shadow-md">
              <img src={capWatcherSCImage} alt="CapWatcher SC" className="w-full h-44 object-cover rounded-3xl mb-5" />
              <h3 className="text-xl font-semibold mb-3">CapWatcher SC</h3>
              <p className="text-gray-600 mb-4">Compact inspection for smaller caps and sensitive closure types where precise quality control is essential.</p>
              <div className="text-sm text-gray-600 space-y-2">
                <p>Designed for specialty closures with tight space and precision requirements.</p>
                <p>Benefits: high-detail surface inspection, print check, cosmetic quality control.</p>
              </div>
              <div className="mt-4">
                <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md text-sm">
                  Know More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default CapsClosuresInspection;
